import { render, staticRenderFns } from "./Snapshot.vue?vue&type=template&id=c0a5ae8e"
import script from "./Snapshot.vue?vue&type=script&lang=ts"
export * from "./Snapshot.vue?vue&type=script&lang=ts"
import style0 from "./Snapshot.vue?vue&type=style&index=0&id=c0a5ae8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports